module.exports = __webpack_public_path__ + "img/logo.14b2f520.png";